var _style, _g, _g2, _g3, _pattern, _path, _pattern2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWaffleBeanie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.3038;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_1_);stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st3{fill:url(#SVGID_00000125569842855206925240000016682499324447478663_);stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("pattern", {
    y: 70,
    width: 2,
    height: 2,
    patternUnits: "userSpaceOnUse",
    id: "Nouveau_motif",
    viewBox: "2.5 -4.5 2 2",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: -4.5,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: -4.5,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: -6.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: -6.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: -6.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: -4.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: -4.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: -4.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: -2.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: -2.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: -2.8,
    className: "st1",
    width: 2.6,
    height: 2.6
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000054973186371890885590000015528917033317206967_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  })), /*#__PURE__*/React.createElement("g", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#Nouveau_motif",
    patternTransform: "matrix(1.2192 0 0 -1.2192 3216.5066 -17317.5371)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.8,51.1c-1.7,1-8.5,2.4-17.3,2.1C25.7,52.9,20.3,52.6,18,51c-2.3-1.6-1.2-3.6-1.2-5.5 c0-1.9,0.2-4.9,0.3-5.7c0.1-0.9,0.2-1.3,1.1-1.4c0.5-0.1,1.2,0,2.3,0c3.5,0.2,10.3,1,15.2,1c4.9,0,11.2-0.2,13.5-0.6 c1-0.2,2-0.5,2.7-0.6c0.8-0.1,1.4,0.1,1.4,1.2c0,2.1,0.2,7.2,0.2,8.3C53.5,48.9,53.5,50.1,51.8,51.1z"
  })), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000095312192059666353300000009761242723389305249_",
    xlinkHref: "#Nouveau_motif",
    patternTransform: "matrix(1.2192 0 0 -1.2192 3216.5066 -17317.5371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095312192059666353300000009761242723389305249_)",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M51.9,38.2c-0.7,0.1-1.7,0.4-2.7,0.6c-2.2,0.4-8.5,0.6-13.5,0.6c-4.9,0-11.7-0.8-15.2-1c-1-0.1-1.8-0.1-2.3,0 c0.3-5.2,0.8-12,4.4-16.2c3.8-4.4,9.6-5.5,11.8-5.5c0.5,0,1,0,1.5,0c2.1,0,8.2,1.2,12.1,5.6C51.2,25.9,51.9,32.5,51.9,38.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWaffleBeanie);
export default __webpack_public_path__ + "static/media/Menu_Waffle_Beanie.c4d8490db007847525fbee137f5dbcf6.svg";
export { ForwardRef as ReactComponent };